import { get, map } from 'lodash';

import { artistServices } from '../services';
import { _showAlert } from '../utils';

export const fetchAllArtists = async (payload) => {
  try {
    const res = await artistServices.fetchAllArtists(payload);
    const data = get(res, 'data.data', []);
    return map(data, (item, index) => {
      return {
        ...item,
        result: `#${index + 1}`,
      };
    });
  } catch (error) {
    console.log(error);
  }
};

export const fetchArtistById = async (id) => {
  try {
    const res = await artistServices.fetchArtistById(id);
    return get(res, 'data.data', {});
  } catch (error) {
    console.log(error);
  }
};

export const fetchArtistSongs = async (id) => {
  try {
    const res = await artistServices.fetchArtistSongs(id);
    const songs = get(res, 'data.data', []);
    return map(songs, (item, index) => {
      return {
        ...item,
        result: `#${index + 1}`,
        thumbnail_img: item.thumbnail_img,
      };
    });
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const fetchArtistWithdrawals = async (id) => {
  try {
    const res = await artistServices.fetchArtistWithdrawals(id);
    const withdrawals = get(res, 'data.data', []);
    return map(withdrawals, (item, index) => {
      return {
        ...item,
        result: `#${index + 1}`,
      };
    });
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const deleteArtist = async (id, shouldDeleteData) => {
  try {
    await artistServices.deleteArtist(id, shouldDeleteData);
    _showAlert('Artist deleted successfully', 'success');
    return true;
  } catch (error) {
    console.log(error.message);
    _showAlert('Something went wrong', 'error');
    return false;
  }
};

export const updateArtist = async (id, data) => {
  try {
    await artistServices.updateArtist(id, data);
    _showAlert('Artist updated successfully', 'success');
    return true;
  } catch (error) {
    console.log(error.message);
    _showAlert('Something went wrong', 'error');
    return false;
  }
};

export const updateWithdrawalStatus = async (id, data) => {
  try {
    await artistServices.updateWithdrawalStatus(id, data);
    _showAlert('Withdrawal status updated successfully', 'success');
    return true;
  } catch (error) {
    console.log(error.message);
    _showAlert('Something went wrong', 'error');
    return false;
  }
};

export const uploadAvatar = async (id, data) => {
  try {
    const res = await artistServices.uploadAvatar(id, data);
    if (get(res, 'data.code') === 'OK' || get(res, 'data.code') === 200 || get(res, 'data.code') === 201) {
      _showAlert('Avatar uploaded successfully', 'success');
      return true;
    }
    return false;
  } catch (error) {
    console.log(error.message);
    _showAlert('Something went wrong', 'error');
    return false;
  }
};

export const getAvatarUploadUrl = async (id, data) => {
  try {
    const res = await artistServices.getAvatarUploadUrl(id, data);
    return get(res, 'data', null);
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const fetchDashboard = async (payload) => {
  try {
    const res = await artistServices.fetchDashboard(payload);
    return get(res, 'data.data', {});
  } catch (error) {
    console.log(error);
    return {};
  }
};

